import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { extraColumnDto } from 'src/app/core/models/Assesment-scheduler/scheduler';

@Component({
  selector: 'app-add-dropdown-option',
  templateUrl: './add-dropdown-option.component.html',
  styleUrls: ['./add-dropdown-option.component.scss'],
})
export class AddDropdownOptionComponent implements OnInit {
  columnObj!: extraColumnDto;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddDropdownOptionComponent>
  ) {
    this.columnObj = data.item;
    if (!this.columnObj.option || this.columnObj.option.length == 0) {
      this.columnObj.option = [''];
    }
  }
  ngOnInit(): void {}
  addInputOption() {
    this.columnObj.option.push('');
  }
  inputOptionValue(event: any, i: number) {
    this.columnObj.option[i] = event.target.value;
  }
  saveOptionValue() {
    this.dialogRef.close({
      columnObj: this.columnObj,
    });
  }
}
